/* global api, msjCesta */
import modal from './modal'
import toastr from 'toastr';
import Swiper, {Navigation}  from 'swiper';
import { createElementFromHTML } from "./helpers";
Swiper.use([Navigation]);

(function () {
    let $overlay, $cesta, $contenido, $cerrar, $body, swiper;
    let ventana = modal();

    $body = document.body;

    let actualizar = (parent) => {
        let clave = parent.getAttribute("data-id");
        let cantidad = parent.querySelector('input[name="cantidad"]').value;
        let $variante = parent.querySelector('select[name="variante_id"]')
        let $servicio = parent.querySelector('select[name="servicio_id"]')
        let servicioId = 0, varianteId = 0;

        if ($variante) {
            varianteId = $variante.value;
        }

        if ($servicio) {
            servicioId = $servicio.value;
        }

        let pmts = {
            clave: clave,
            cantidad: cantidad,
            servicio_id: servicioId,
            variante_id: varianteId,
        };
        NProgress.start();
        axios.post(api.cestaActualizar, pmts)
            .then(function (response) {
                abrir(response.data);
            })
            .catch(function (error) {
                console.log("-> error", error);
            })
            .finally(function () {
                NProgress.done();
            });
    }

    let borrar = (parent) => {
        let clave = parent.getAttribute("data-id");

        let pmts = {
            clave: clave
        };

        NProgress.start();
        axios.post(api.cestaBorrar, pmts)
            .then(function (response) {
                abrir(response.data);
            })
            .catch(function (error) {
                console.log("-> error", error);
            })
            .finally(function () {
                NProgress.done();
            });
    }

    let actualizarNroItemsMenu = (parent) => {
        let nroItems = 0;
        let $nroItems = parent.querySelector("[data-nro-items]");
        if ($nroItems) {
            nroItems = parseInt($nroItems.getAttribute("data-nro-items"));
            let $nroItemsMenu = document.querySelector(".nro-items-cesta");
            if (nroItems > 0) {
                $nroItemsMenu.innerText = ""+nroItems;
                $nroItemsMenu.classList.remove("hidden");
            } else {
                $nroItemsMenu.innerText = "0";
                $nroItemsMenu.classList.add("hidden");
            }
        }
    };

    let inicializarContenido = () => {
        let $lista = $contenido.querySelector("[data-lista]");
        actualizarNroItemsMenu($contenido);

        if ($lista) {
            $lista.addEventListener("click", (e) => {
                if(e.target) {
                    let actualizable = false;
                    let parent = e.target.closest("[data-id]")
                    let $cantidad = parent.querySelector('input[name="cantidad"]');
                    let cantidad = $cantidad.value;

                    if(e.target.hasAttribute("data-aumentar")) {
                        cantidad++;
                        actualizable = true;
                    }

                    if(e.target.hasAttribute("data-disminuir")) {
                        cantidad--;
                        if (cantidad < 1) {
                            cantidad = 1;
                        }
                        actualizable = true;
                    }

                    if (actualizable) {
                        $cantidad.value = cantidad;
                    }

                    if(e.target.hasAttribute("data-borrar")) {
                        borrar(parent);
                    }

                    if (actualizable) {
                        actualizar(parent);
                    }
                }

            });

            $lista.addEventListener('change', (e) => {
                if(e.target) {
                    let parent = e.target.closest("[data-id]");
                    actualizar(parent);
                }
            });
        }

        let $btnRequerirLogin = document.querySelector("[data-requrir-login]")

        if ($btnRequerirLogin) {
            $btnRequerirLogin.addEventListener("click", () => {
                let $btnLoginAlta = document.querySelector(".usuario-btn-menu");

                if($btnLoginAlta) {
                    localStorage.setItem("requerir-checkout", "si");
                    cerrar();
                    $btnLoginAlta.dispatchEvent(new Event('solicitud-login'));
                }
            })
        }

        inicializarListas($cesta.querySelectorAll("[data-cesteable]"), true);
    }

    let abrir = (contenido) => {
        $contenido.innerHTML = contenido;
        $cesta.classList.add("visible");
        $overlay.classList.add("visible");
        $body.classList.add("overflow-hidden");
        inicializarContenido();
    };

    let cerrar = () => {
        $cesta.classList.remove("visible");
        $overlay.classList.remove("visible");
        if (swiper) {
            swiper.destroy();
        }
        $contenido.innerHTML = "";
        $body.classList.remove("overflow-hidden");
    };

    let iniciarFormularios = () => {
        let $form = document.querySelector(".modal form.cesta-agregar")

        if ($form) {
            $form.addEventListener("submit", (e) => {
                e.preventDefault();

                const formData = new FormData(e.target)
                const url = e.target.getAttribute("action")+"?v="+(new Date().getTime());


                NProgress.start();
                axios.post(url, formData)
                    .then(function (response) {
                        ventana.open({content: response.data});
                        let ok = document.querySelector(".modal [data-ok]");

                        if(ok) {
                            actualizarNroItemsMenu(document.querySelector(".modal"));
                            ventana.close();
                            toastr.success('Producto agregado al carrito');
                        } else {
                            iniciarFormularios();
                        }
                    })
                    .catch(function (error) {
                        console.log("-> error", error);
                    })
                    .finally(function () {
                        NProgress.done();
                    });
            });
        }
    };

    let inicializarListas = (cesteables, abrirAlAgregar) => {
        cesteables.forEach(function (el) {
            el.addEventListener("click", (e) => {
                if(e.target && e.target.hasAttribute("data-agregar")) {
                    let id = e.target.getAttribute("data-agregar");

                    let pmts = {
                        v: new Date().getTime()
                    };
                    NProgress.start();

                    axios.get(api.cestaAgregar+"/"+id, {params: pmts})
                        .then(function (response) {
                            ventana.open({content: response.data})
                            let ok = document.querySelector(".modal [data-ok]");

                            if(ok) {
                                actualizarNroItemsMenu(document.querySelector(".modal"));
                                ventana.close();
                                toastr.success(msjCesta.agregado);
                                if(abrirAlAgregar) {
                                    btnMenuCarrito.click();
                                }
                            } else {
                                iniciarFormularios();
                            }
                        })
                        .catch(function (error) {
                            console.log("-> error", error);
                        })
                        .finally(function () {
                            NProgress.done();
                        });
                }
            });
        });
    };

    inicializarListas(document.querySelectorAll("[data-cesteable]"));

    let inicializarFormVerProducto = () => {
        let $formAgregar = document.querySelector("form.cesta-agregar-full");

        if ($formAgregar) {

            let $cantidad = $formAgregar.querySelector('input[name="cantidad"]');

            if ($cantidad) {
                let $btnAumentar = $formAgregar.querySelector("[data-aumentar]");
                let $btnDisminuir = $formAgregar.querySelector("[data-disminuir]");
                let cantidad = $cantidad.value;

                $btnAumentar.addEventListener("click", (e) => {
                    e.preventDefault();
                    cantidad++;
                    $cantidad.value = cantidad;
                });

                $btnDisminuir.addEventListener("click", (e) => {
                    e.preventDefault();
                    cantidad--;
                    if (cantidad < 1) {
                        cantidad = 1;
                    }
                    $cantidad.value = cantidad;
                });

                $formAgregar.addEventListener("submit", (e) => {
                    e.preventDefault();

                    const formData = new FormData(e.target)
                    const url = e.target.getAttribute("action")+"?v="+(new Date().getTime());


                    NProgress.start();
                    axios.post(url, formData)
                        .then(function (response) {
                            ventana.open({content: response.data});
                            let ok = document.querySelector(".modal [data-ok]");

                            if(ok) {
                                actualizarNroItemsMenu(document.querySelector(".modal"));
                                toastr.success('Producto agregado al carrito');
                            }

                            let $mensajes = document.querySelector(".modal [data-mensajes]");
                            if ($mensajes) {
                                toastr.warning($mensajes.innerHTML);
                            }
                            ventana.close();
                        })
                        .catch(function (error) {
                            console.log("-> error", error);
                        })
                        .finally(function () {
                            NProgress.done();
                        });
                });
            }

        }
    }

    inicializarFormVerProducto();

    let btnMenuCarrito = document.querySelector(".carrito-btn-menu");

    if (btnMenuCarrito) {
        btnMenuCarrito.addEventListener("click", (e) => {
            e.preventDefault();
            let pmts = {
                v: new Date().getTime()
            };
            NProgress.start();
            axios.get(api.cesta, {params: pmts})
                .then(function (response) {
                    abrir(response.data);
                })
                .catch(function (error) {
                    console.log("-> error", error);
                })
                .finally(function () {
                    NProgress.done();
                });
        });
    }

    $overlay = createElementFromHTML('<div class="overlay"></div>');

    $cesta = createElementFromHTML('<div class="cesta"></div>');
    $contenido = createElementFromHTML('<div class="contenido"></div>');

    $cerrar = createElementFromHTML('<div class="cerrar">\n' +
        '            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '                <path\n' +
        '                    d="M21 1.8375L19.1625 0L10.5 8.6625L1.8375 0L0 1.8375L8.6625 10.5L0 19.1625L1.8375 21L10.5 12.3375L19.1625 21L21 19.1625L12.3375 10.5L21 1.8375Z"\n' +
        '                    fill="black"/>\n' +
        '            </svg>\n' +
        '        </div>');

    $cesta.append($contenido);
    $cesta.append($cerrar);

    document.addEventListener("DOMContentLoaded", function(event) {
        let $overLayAnterior = document.querySelector(".overlay");
        if ($overLayAnterior) {
            $overlay = $overLayAnterior;
        } else {
            document.body.append(($overlay))
        }
        document.body.append(($cesta))
        $overlay.addEventListener("click", cerrar)
    });

    $cerrar.addEventListener("click", cerrar)

    let $buscador = document.getElementById("buscador");

    if ($buscador) {
        $buscador.addEventListener("buscador", () => {
            let resultado = document.getElementById("resultado");
            inicializarListas(resultado.querySelectorAll("[data-cesteable]"));
        })
    }
})();
